import { Observable } from 'rxjs';
import axios from 'axios';
import AxiosSubscriber from './AxiosSubscriber';

axios.defaults.baseURL = JSON.parse(process.env.VUE_APP_USE_ENV) ? '${VUE_APP_API_BASE_URL}' : process.env.VUE_APP_API_BASE_URL;

// default headers
axios.interceptors.request.use((config) => {
  config.headers = Object.assign(config.headers, {
    'Content-Type': 'application/json',
  });

  return config;
});

const getQuery = function getQuery(params) {
  return Object.keys(params).map((key) => `${key}=${params[key]}`).join('&');
};
const transformResponse = {
  success(res) {
    return { response: res.data, status: res.status };
  },
  error(err) {
    return err.response;
  },
};

export default {
  get(source, params, headers, config) {
    const query = params ? `?${getQuery(params)}` : '';

    return Observable.create((observer) => {
      let baseConfig = {
        method: 'get',
        url: `${source}${query}`,
        headers,
        customResponse: transformResponse,
      };

      if (config) baseConfig = Object.assign(baseConfig, config);
      return new AxiosSubscriber(observer, baseConfig);
    });
  },

  post(source, data, headers, config) {
    return Observable.create((observer) => {
      let baseConfig = {
        method: 'post',
        url: source,
        data: data || {},
        headers,
        customResponse: transformResponse,
      };

      if (config) baseConfig = Object.assign(baseConfig, config);
      return new AxiosSubscriber(observer, baseConfig);
    });
  },

  patch(source, data, headers, config) {
    return Observable.create((observer) => {
      let baseConfig = {
        method: 'patch',
        url: source,
        data: data || {},
        headers,
        customResponse: transformResponse,
      };

      if (config) baseConfig = Object.assign(baseConfig, config);
      return new AxiosSubscriber(observer, baseConfig);
    });
  },

  put(source, data, headers, config) {
    return Observable.create((observer) => {
      let baseConfig = {
        method: 'put',
        url: source,
        data: data || {},
        headers,
        customResponse: transformResponse,
      };

      if (config) baseConfig = Object.assign(baseConfig, config);
      return new AxiosSubscriber(observer, baseConfig);
    });
  },

  delete(source, target, headers, config) {
    return Observable.create((observer) => {
      let baseConfig = {
        method: 'delete',
        url: `${source}/${target}`,
        headers,
        customResponse: transformResponse,
      };

      if (config) baseConfig = Object.assign(baseConfig, config);
      return new AxiosSubscriber(observer, baseConfig);
    });
  },
};
